import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loading from '@betwixt/common/components/Loading.js';
import DynamicImport from './DynamicImport.js';

class CreateComponent extends Component {
  render() {
    const {
      moduleId,
      endpointComponent,
      moduleConfig,
      moduleUrl,
      pagename,
      t,
      i18n,
      client,
      gConfig,
      User,
    } = this.props;

    return (
      <DynamicImport
        moduleId={moduleId}
        pagename={pagename}
        moduleUrl={moduleUrl}
        moduleConfig={moduleConfig}
        t={t}
        i18n={i18n}
        client={client}
        gConfig={gConfig}
        User={User}
        load={() =>
          import(
            /* webpackExclude: /([\\/]server[\\/]|[\\/]__tests__[\\/]|\.(test|spec)\.js$)/ */
            `@betwixt/common/modules/${endpointComponent}`
          )
        }
      >
        {(Component) =>
          Component === null ? <Loading type="ring" /> : <Component {...this.props} />
        }
      </DynamicImport>
    );
  }
}
export default CreateComponent;

CreateComponent.propTypes = {
  moduleId: PropTypes.string.isRequired,
  endpointComponent: PropTypes.string.isRequired,
  moduleConfig: PropTypes.object.isRequired,
  moduleUrl: PropTypes.string.isRequired,
  pagename: PropTypes.string,
  t: PropTypes.func,
  i18n: PropTypes.object,
  client: PropTypes.object,
  gConfig: PropTypes.object,
  User: PropTypes.object,
  children: PropTypes.func.isRequired,
  load: PropTypes.func,
};
